// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"0104af16","128":"98172248","240":"d4a30a1c","246":"01e4663a","256":"e795e119","368":"34c1086a","463":"74d2aad3","580":"f451429e","651":"5c89db96","689":"46252ebb"}[chunkId] + ".chunk.js";
};